import { useEffect, useRef } from "react";

const useDidMountEffect = (func, cleanUp, deps) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) func();
    else didMount.current = true;

    return cleanUp;
    // deps is the caller-provided dependency list itself; spreading it here (not wrapping it
    // in [deps]) is what makes this hook actually skip firing until one of those values
    // changes, instead of on every re-render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export default useDidMountEffect;
